<script>
export default {
    name: 'AccountFormError',
    props: {
        property: String,
        errorObj: Object
    },
};
</script>

<template>
    <div class="error-message"  v-if="property in errorObj">
        <span v-for="err in errorObj[property]" :key="err">
            {{err}}
        </span>
    </div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/form.scss';
</style>
